module.exports = __webpack_public_path__ + "img/bg.7a16c786.png";